import React from "react";
import Topmessage from "./Questionbody.module.css"

function Toptext() {
  return (
    <div>
      <div className={Topmessage.topmessage}>
        Frequently Asked Questions (FAQs) on Aphrodite TOP QUESTIONS Here is a
        list of the top questions we receive from users just starting out on
        Aphrodite.
      </div>
      <br />
      <br />
    </div>
  );
}

export default Toptext;
